// extracted by mini-css-extract-plugin
export default {"formWrapper":"Radio_formWrapper","radio":"Radio_radio","frame":"Radio_frame"};